import React from 'react';

import {
  StyledCard,
  StyledCardHeader,
  StyledCardMedia,
  StyledCardContent,
  StyledCardActions,
} from './styled';

const Card = ({ children, horizontal, reverse }) => {
  return (
    <StyledCard horizontal={horizontal} reverse={reverse}>
      {children}
    </StyledCard>
  );
};

export const CardHeader = ({ children }) => {
  return <StyledCardHeader>{children}</StyledCardHeader>;
};

export const CardMedia = ({ children, imageSrc, size }) => {
  return (
    <StyledCardMedia imageSrc={imageSrc} size={size}>
      {children}
    </StyledCardMedia>
  );
};

export const CardContent = ({ children }) => {
  return <StyledCardContent>{children}</StyledCardContent>;
};

export const CardActions = ({ children }) => {
  return <StyledCardActions>{children}</StyledCardActions>;
};

export default Card;
